import { useState, useEffect } from 'react';

/**
 * Hook para detectar si estamos en una pantalla móvil (≤768px)
 * @returns {boolean} true si el ancho de pantalla es ≤480px
 */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Función para verificar el tamaño de pantalla
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Verificar al montar
    checkMobile();

    // Escuchar cambios de tamaño
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile;
};

export default useIsMobile;












